import React, { useMemo } from "react";

function DispatchPendingTable({ rows }) {
  // Totals for footer (plan-level)
  const totals = useMemo(() => {
    let planned = 0, logistic = 0, invoice = 0;
    for (const r of rows) {
      planned  += parseFloat(r.planned_qty) || 0;
      logistic += parseFloat(r.logistic_planned_qty ?? r.dispatch_rows ?? 0) || 0;
      invoice  += parseFloat(r.invoice_qty) || 0;
    }
    return { planned, logistic, invoice };
  }, [rows]);

  return (
    <div className="container-fluid mt-4 px-0">
      <div className="table-responsive">
        <table className="table table-bordered table-hover w-100">
          <thead className="table-light">
            <tr>
              <th>Customer</th>
              <th>Delivery Date</th>
              <th>Loading Point (Plan)</th>
              <th>Destination</th>
              <th>Material</th>
              <th>Packing Type</th>
              <th>Planned Qty (Plan)</th>

              {/* per-vehicle detail */}
              <th>Vehicle Planning Date</th>
              <th>Vehicle No</th>
              <th>Vehicle Planned Qty</th>
              <th>Invoice Date (Veh)</th>
              <th>Invoice Qty (Veh)</th>

              {/* plan-level summary */}
              
            
            </tr>
          </thead>

          <tbody>
            {rows.length === 0 ? (
              <tr><td colSpan="16" className="text-center">No data</td></tr>
            ) : rows.map((r, i) => {
              const vs = Array.isArray(r.vehicles) && r.vehicles.length ? r.vehicles : [null];
              const span = vs.length;
              const logisticPlanned = r.logistic_planned_qty ?? r.dispatch_rows ?? 0;

              return vs.map((v, idx) => (
                <tr key={`${r.plan_id || r.sales_order_id || i}-${idx}`}>
                  {idx === 0 && (
                    <>
                      <td rowSpan={span}>{r.customer_name}</td>
                      <td rowSpan={span}>{r.delivery_date || ""}</td>
                      <td rowSpan={span}>{r.loading_point || ""}</td>
                      <td rowSpan={span}>{r.destination_point || ""}</td>
                      <td rowSpan={span}>{r.material_name}</td>
                     <td rowSpan={span}>
  {r.packing_type || ""}
  {r.remark ? (
    <>
      <br />
      <span style={{ color: "red" }}>{r.remark}</span>
    </>
  ) : null}
</td>

                       <td rowSpan={span}>{Number(r.planned_qty ?? 0).toFixed(3)}</td>
                    </>
                  )}

                  {/* per-vehicle cells */}
                  <td>{v?.dispatch_date || ""}</td>
                  <td>{v?.vehicle_no || ""}</td>
                  <td>{v?.vehicle_planned_qty != null ? Number(v.vehicle_planned_qty).toFixed(3) : ""}</td>
                  <td>{v?.invoice_date || ""}</td>
                  <td className={v && v.vehicle_invoice_qty > 0 ? "table-success" : ""}>
                    {v?.vehicle_invoice_qty != null ? Number(v.vehicle_invoice_qty).toFixed(3) : ""}
                  </td>

                 
                </tr>
              ));
            })}
          </tbody>

          <tfoot className="table-light">
            <tr>
              {/* merge the first 12 columns (up to Invoice Qty (Veh)) */}
              <td colSpan="6" className="text-end fw-bold">Totals:</td>
              <td className="fw-bold">{totals.planned.toFixed(3)}</td>
              <td>  </td><td>  </td>
              <td className="fw-bold">{totals.logistic}</td>
              <td>  </td>
              <td className="fw-bold">{totals.invoice.toFixed(3)}</td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>
  );
}

export default DispatchPendingTable;
